import { render, staticRenderFns } from "./clickplay.vue?vue&type=template&id=49cefab7&scoped=true&"
import script from "./clickplay.vue?vue&type=script&lang=js&"
export * from "./clickplay.vue?vue&type=script&lang=js&"
import style0 from "./clickplay.vue?vue&type=style&index=0&id=49cefab7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cefab7",
  null
  
)

export default component.exports